export default {
  field: {
    type: 'Loại',
    code: 'Mã',
    agencyDebitAccount: 'Tài khoản công nợ',
    transactionCode: 'Mã giao dịch',
    subTransactionCode: 'Mã giao dịch phụ',
    timeFrame: 'Khung giờ',
    chargesAmount: 'Mức phí',
    chargesAmountValue: 'Mức phí',
    chargesAmountValuePercent: 'Phần trăm mức phí',
    chargesAmountValueMoney: 'Số tiền mức phí',
    currencyUnit: 'Đơn vị tiền tệ',
    equivalentRoomNight: 'Đêm phòng tương đương',
    timeFrameStart: 'Khung giờ bắt đầu',
    timeFrameEnd: 'Khung giờ kết thúc',
    packageCategoryCode: 'Mã danh mục',
    desc: 'Mô tả',
    active: 'Hoạt động',
    packageCodeName: 'Mã/Tên gói',
    saleDate: 'Ngày bán',
    packageCode: 'Mã gói',
    saleStartDate: 'Ngày bắt đầu bán',
    saleEndDate: 'Ngày kết thúc bán',
    packageName: 'Tên gói',
    packageCategory: 'Danh mục gói',
    transactionCodeOfPackage: 'Mã giao dịch của gói',
    tansactionPage: 'Trang giao dịch',
    currency: 'Tiền tệ',
    includeTaxFee: 'Bao gồm thuế, phí',
    frequenceOfUsingService: 'Tần suất sử dụng dịch vụ',
    billingRule: 'Quy tắc tính tiền',
    packagePriceInPriceCode: 'Giá gói khi bán trong mã giá',
    displayWhenSaleInPriceCode: 'Hiển thị khi bán trong mã giá',
    enableSaleIndividually: 'Cho phép bán riêng',
    effectiveDate: 'Ngày có hiệu lực',
    expiryDate: 'Ngày hết hiệu lực',
    unitPrice: 'Đơn giá',
    allDaysInWeek: 'Tất cả các ngày trong tuần',
    applicablePeopleAmount: 'Số lượng người áp dụng',
    applicableNightAmount: 'Số lượng đêm',
    maxPeopleAmount: 'Số lượng người tối đa',
    minPeopleAmount: 'Số lượng người tối thiểu',
    maxNightAmount: 'Số lượng đêm tối đa',
    minNightAmount: 'Số lượng đêm tối thiểu',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    object: 'Đối tượng',
    mainInformation: 'Thông tin chính',
    searchInformation: 'Thông tin tìm kiếm',
    order: 'Thứ tự',
    priceCode: 'Mã giá',
    priceCategory: 'Danh mục giá',
    transactionRoomRate: 'Giao dịch tiền phòng',
    orderDisplay: 'Thứ tự hiển thị',
    includeMeal: 'Bao gồm bữa ăn',
    package: 'Gói',
    priceDaily: 'Giá hàng ngày',
    stopSelling: 'Ngừng bán',
    marketSegment: 'Phân khúc thị trường',
    source: 'Nguồn',
    pricePeriod: 'Giá giai đoạn',
    packageGroupPackageCodeOrName: 'Mã/tên gói, nhóm gói',
    showExpiredPackage: 'Hiển thị gói đã hết hạn',
    periodCode: 'Mã giai đoạn',
    period: 'Giai đoạn',
    showInactiveRoomServiceGroup:
      'Hiển thị nhóm dịch vụ buồng phòng không hoạt động',
    groupCode: 'Mã nhóm',
    groupName: 'Tên nhóm',
    transaction: 'Giao dịch',
    subTransaction: 'Giao dịch phụ',
    defaultTransactionPage: 'Trang giao dịch mặc định',
    category: 'Danh mục',
    productNameOrCode: 'Tên/Mã sản phẩm',
    breakfastCode: 'Mã ăn sáng',
    adultPrice: 'Giá người lớn',
    childPrice: 'Giá trẻ con',
    notIncludingInRoomRate: 'Không bao gồm trong tiền phòng',
    transactionPage: ' Trang giao dịch',
    feeAmount: 'Số tiền phí',
    quantityInStock: 'Số lượng trong kho',
    manageSaleQuantity: 'Quản lý số lượng bán',
    separateFromRoomRate: 'Tách ra từ tiền phòng',
    openPrice: 'Giá mở',
    monthlyFee: 'Phí hàng tháng',
    dayInWeek: 'Ngày trong tuần',
    time: 'Thời gian',
    startTime: 'Thời gian bắt đầu',
    endTime: 'Thời gian kết thúc',
    amountOfMoney: 'Số tiền',
    roomLevel: 'Hạng phòng',
    fullName: 'Họ và tên',
    firstName: 'Họ',
    lastName: 'Tên',
    title: 'Danh xưng',
    dateOfBirth: 'Ngày sinh',
    phoneNumber: 'Số điện thoại',
    sex: 'Giới tính',
    email: 'Email',
    checkInDate: 'Ngày đến',
    checkOutDate: 'Ngày đi',
    amountOfNight: 'Số đêm',
    adultAndChild: 'Người lớn - Trẻ em dưới 5 tuổi',
    status: 'Trạng thái',
    realRoomLevel: 'Hạng phòng thực',
    bookedRoomLevel: 'Hạng phòng đặt',
    bookMultipleRooms: 'Đặt nhiều phòng',
    roomBooking: 'Phòng đặt',
    breakfast: 'Bữa sáng',
    groupAndSubGroup: 'Đoàn - Đoàn phụ',
    walkInCustomer: 'Khách Walk-in',
    longTermStay: 'Ở dài hạn',
    lockChangeRoom: 'Khóa chuyển phòng',
    notAddService: 'Không thêm dịch vụ',
    reminderDate: 'Ngày nhắc',
    travelCompanyAndAgency: 'Công ty, đại lý du lịch',
    debtAccount: 'Tài khoản công nợ',
    saleStaff: 'Nhân viên kinh doanh',
    internal: 'Nội bộ',
    free: 'Miễn phí',
    notPrintPrice: 'Không in giá',
    additonalPackage: 'Gói bổ sung',
    packageInPriceCode: 'Gói trong mã giá',
    manualPrice: 'Tự nhập giá',
    updateWhenCheckIn: 'Cập nhật khi check in',
    currencyAndExchangeRate: 'Tiền tệ - Tỉ giá',
    saleOff: 'Giảm giá',
    nightAmountForDiscount: 'Đêm giảm giá',
    saleOffReason: 'Lý do giảm giá',
    paymentMethod: 'Phương thức thanh toán',
    creditCard: 'Thẻ tín dụng',
    cardOwner: 'Chủ thẻ',
    honorifics: 'Danh xưng',
    rentType: 'Loại hình thuê',
    numOfAdult: 'Số người lớn',
    numOfChildren: 'Số trẻ em',
    confirmCode: 'Mã xác nhận',
    externalConfirmCode: 'Mã định danh ngoài',
    bookingPerson: 'Tên người đặt',
    firstArriveDate: 'Ngày đến đầu',
    lastDepartureDate: 'Ngày đi cuối',
    numberNight: 'Số đêm',
    nameGroup: 'Tên đoàn',
    color: 'Màu sắc',
    typeofRent: 'Loại hình cho thuê',
    longTerm: 'Dài hạn',
    shortTerm: 'Ngắn hạn',
    releaseDate: 'Ngày nhả phòng',
    note: 'Ghi chú',
    companyAgent: 'Công ty, đại lý du lịch',
    companyAgent2: 'Công ty, đại lý du lịch 2',
    businessEmployee: 'Nhân viên kinh doanh',
    debitAccount: 'Tài khoản công nợ',
    noPrintPrice: 'Không in giá',
    mainAccount: 'Tài khoản chính',
    hasBreakfast: 'Bữa sáng',
    noExtraService: 'Không thêm dịch vụ',
    transInMaster: 'Chuyển tiền đến phòng master',
    payMethod: 'Phương thức thanh toán',
    arrivingVehicle: 'Phương tiện đến',
    limitCredit: 'Giới hạn tín dụng',
    arrivingTime: 'Thời gian đến',
    leavingVehicle: 'Phương tiện đi',
    leavingTime: 'Thời gian đi',
    representPerson: 'Tên người đại diện',
    address_1: 'Địa chỉ 1',
    address_2: 'Địa chỉ 2',
    other_documents: 'Giấy tờ khác',
    temporary_residency_card_number: 'Thẻ cư trú',
    visa_number: 'Visa',
    fax: 'Fax',
    addComment: 'Thêm bình luận',
    roomNo: 'Số phòng',
    hotel: 'Khách sạn',
    attribute: 'Thuộc tính',
    onlyShowAvailableRoom: 'Chỉ hiện phòng sẵn sàng',
    titleAssignTraveller: 'Gán hồ sơ vào đặt phòng',
    titleAddAssignTraveller: 'Thêm hồ sơ',
    titleSpecialService: 'Dịch vụ đặc biệt',
    quantity: 'Số lượng',
    specialUnitPrice: 'Giá đơn vị',
    profile: 'Hồ sơ',
    nation: 'Quốc gia',
    nationality: 'Quốc tịch',
    customerClass: 'Hạng khách',
    memberCount: 'Số thành viên',
    mainGuest: 'Khách chính',
    children: 'Trẻ em',
    identityCardNumber: 'Số căn cước',
    passport: 'Hộ chiếu',
    placeOfIssue: 'Nơi cấp',
    dateOfIssue: 'Ngày cấp',
    dateOfExpiry: 'Ngày hết hạn',
    arrivalDate: 'Ngày đến',
    departureDate: 'Ngày đi',
    missionInfo: 'Thông tin nhiệm vụ',
    department: 'Bộ phận',
    implementDate: 'Ngày thực hiện',
    implementTime: 'Thời gian thực hiện',
    content: 'Nội dung',
    groupCodeOrGroupPackName: 'Mã nhóm/Tên nhóm gói',
    showInactivePackGroup: 'Hiển thị nhóm gói không hoạt động',
    packGroupCode: 'Mã nhóm gói',
    packGroupName: 'Tên nhóm gói',
    cardId: 'ID Thẻ',
    recode: 'Recode',
    receptionist: 'Lễ tân',
    bookingGroup: 'Đoàn',
    room: 'Phòng',
    groupService: 'Nhóm dịch vụ',
    roomStatus: 'Trạng thái phòng',
    updatedByPerson: 'Người cập nhật',
    subGroup: 'Đoàn phụ',
    rankOrder: 'Hạng đặt',
    numOfRoom: 'Số lượng phòng',
    numOfGuest: 'Số lượng khách',
    fromDateToDate: 'Từ ngày - Đến ngày',
    reason: 'Lý do',
    date: 'Ngày',
    colorCode: 'Mã màu',
    operation: 'Thao tác',
    showRoomServiceGroup: 'Hiển thị nhóm dịch vụ buồng phòng',
    depositMoney: 'Số tiền đặt cọc',
    receiveAccount: 'Tài khoản nhận',
    cardNumber: 'Số thẻ',
    deposit: 'Đặt cọc',
    packagePackageGroupCode: 'Mã gói/Mã nhóm gói',
    vietnameseName: 'Tên Việt Nam',
    englishName: 'Tên Tiếng Anh',
    applyFor: 'Áp dụng cho',
    guestSource: 'Nguồn khách',
    segment: 'Segment',
    agency: 'Đại lý',
    startDate: 'Ngày bắt đầu',
    endDate: 'Ngày kết thúc',
    discount: 'Giảm giá',
    discountAmountValueMoney: 'Số tiền giảm giá',
    discountAmountValuePercent: 'Phần trăm giảm giá',
    inventory: 'Inventory',
    amountOfLimit: 'Số lượng giới hạn',
    minTotalBookingFee: 'Tổng tiền booking tối thiểu',
    minTotalNightStay: 'Tổng số đêm lưu trú tối thiểu',
    bookingDayInAdvance: 'Số ngày đặt Booking trước',
    customerName: 'Tên khách',
    bookingGroupName: 'Tên Đoàn',
    agentName: 'Đại lý du lịch/AR',
    lockID: 'ID khóa từ',
    returnStatus: 'Trả về trạng thái',
    validTime: 'Thời gian hiệu lực',
    password: 'Mật khẩu',
    passwordConfirm: 'Mật khẩu xác nhận',
    month: 'Tháng',
    dateRange: 'Khoảng ngày',
    account: 'Tài khoản',
    addCharge: 'Phụ thu phí',
    oldPassword: 'Mật khẩu cũ',
    newPassword: 'Mật khẩu mới',
    addRoom: 'Thêm phòng',
    addNumOfRoom: 'Số lượng phòng thêm',
    addNumOfGuest: 'Số lượng khách thêm',
    invoiceNum: 'Mã hóa đơn',
    ticketType: 'Loại vé',
    product: 'Sản phẩm',
    comboType: 'Loại combo'
  }
}
